import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  input,
  OnChanges,
  output,
  SimpleChanges
} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-save-btn',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './save-btn.component.html',
  styleUrl: './save-btn.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('buttonState', [
      state('idle', style({transform: 'scale(1)'})),
      state('saving', style({transform: 'scale(0.95)'})),
      state('saved', style({transform: 'scale(1.15)'})),
      transition('idle => saving', animate('200ms ease-in')),
      transition('saving => saved', animate('200ms ease-out')),
      transition('saved => idle', animate('200ms ease-in'))
    ])
  ]
})
export class SaveBtnComponent implements OnChanges {
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  element = input.required<any>();
  disabled = input<boolean>(false);
  clicked = output<boolean>();
  savingDone = output<boolean>();

  isSaving = false;
  animationState: 'idle' | 'saving' | 'saved' = 'idle';
  buttonLabel = 'Save';

  private savingStarted?: ReturnType<typeof setTimeout>;
  private savedTimeout?: ReturnType<typeof setTimeout>;

  constructor() {
    this.destroyRef.onDestroy(() => {
      clearTimeout(this.savingStarted);
      clearTimeout(this.savedTimeout);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['element'] && !changes['element'].firstChange) {
      if (JSON.stringify(changes['element'].previousValue) !== JSON.stringify(changes['element'].currentValue)) {
        this.startSavingAnimation();
      }
    }
  }

  saveElement() {
    if (this.isSaving) {
      return;
    }
    this.clicked.emit(true);
    this.isSaving = true;
    this.animationState = 'saving';
    this.buttonLabel = 'Saving...';
    this.cdr.detectChanges();
    this.startSavingAnimation();
  }


  private startSavingAnimation() {
    if (this.savingStarted) {
      return;
    }
    this.savingStarted = setTimeout(() => {
      this.animationState = 'saved';
      this.buttonLabel = 'Saved!';
      this.cdr.detectChanges();

      this.savedTimeout = setTimeout(() => {
        this.animationState = 'idle';
        this.buttonLabel = 'Save';
        this.isSaving = false;
        this.savingStarted = undefined;
        this.savedTimeout = undefined;
        this.savingDone.emit(true);
        this.cdr.detectChanges();
      }, 1000);
    }, 2000);
  }
}
